<template>
  <div
    class="wrapper pa-4"
  >
    <h1 class="d-flex mb-2">
      <v-icon>mdi-horse-variant-fast</v-icon>
      <VSpacer />
      <v-btn @click="fullscreen">
        全屏
      </v-btn>
    </h1>
    <div class="relative full-bleed">
      <canvas
        id="c3"
        style="border: 1px solid;max-height: 65vh;width: 100%;"
      />
    </div>
  </div>
</template>

<script>
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
const loader = new GLTFLoader();

export default {
  data() {
    return {
      state3: {
        time: 0,
      },
      renderer3: null,
      scene: null,
      camera: null,
      horseData: null,
    };
  },
  mounted() {
    this.init3();
    this.animate3();
  },
  // 组件销毁
  beforeDestroy() {
    // 销毁？？
    this.renderer.dispose();
  },
  methods: {
    async init3() {
      // canvas
      const canvas = document.querySelector('#c3');
      // 渲染器 antialias代表是否开启抗锯齿
      this.renderer = new THREE.WebGLRenderer({antialias: true, canvas});
      this.camera = new THREE.PerspectiveCamera(100, 2, 0.1, 1000);

      // 摄像机位置 xyz
      this.camera.position.set( 100, 200, 100);
      // this.camera.lookAt( 0, 0, 0 );

      const controls = new OrbitControls( this.camera, canvas );
      // target
      controls.target.set( 0, 0, 0 );
      controls.update();
      
      // 创建场景
      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color( 'black' );


      {
        // 加载 glb 文件
        const scene = this.scene;
        loader.load( 'https://cdn.jsdelivr.net/gh/miloweimo/blogimage/Horse.glb', function ( gltf ) {
          scene.add( gltf.scene );
        }, undefined, function ( error ) {
          console.error( error );
        } );
      }

      // 场景+灯光
      const color = 0xFFFFFF;
      const intensity = 3;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4); // 位置
      this.scene.add(light);
      const light2 = new THREE.DirectionalLight(color, intensity);
      light2.position.set(1, -2, 4); // 位置
      this.scene.add(light2);
      const light3 = new THREE.DirectionalLight(color, intensity);
      light3.position.set(1, 3, 4); // 位置
      this.scene.add(light3);
      const light4 = new THREE.DirectionalLight(color, intensity);
      light4.position.set(-1, -3, 4); // 位置
      this.scene.add(light4);

      // 之后将场景和摄像机传递给渲染器来渲染出整个场景。
      this.renderer.render(this.scene, this.camera);
    },
    updateCamera() {
      this.camera.updateProjectionMatrix();
    },

    // 判断画布是否需要调整大小
    resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        renderer.setSize(width, height, false);
      }
      return needResize;
    },
    render3() {
      // 注意如果我们的canvas大小被调整了那函数会返回true。我们可以利用 这个来检查是否有其他的东西应该更新。我们修改渲染循环 来使用我们的新函数
      if (this.resizeRendererToDisplaySize(this.renderer)) {
        const canvas = this.renderer.domElement;
        this.camera.aspect = canvas.clientWidth / canvas.clientHeight;
        this.camera.updateProjectionMatrix();
      }

      this.renderer.render(this.scene, this.camera);

      requestAnimationFrame(this.render3);
    },
    animate3(time) {
      this.state3.time = time * 0.01;
      this.render3();
    
      requestAnimationFrame(this.animate3);
    },
    fullscreen() {
      const canvas = document.querySelector('#c3');
      if (canvas.requestFullscreen) {
        canvas.requestFullscreen();
      } else if (canvas.webkitRequestFullscreen) {
        canvas.webkitRequestFullscreen();
      } else if (canvas.mozRequestFullScreen) {
        canvas.mozRequestFullScreen();
      } else if (canvas.msRequestFullscreen) {
        canvas.msRequestFullscreen();
    }
    },
  }
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

/* 移动端换行 */
a {
  word-break: break-all;
}

</style>